module.exports = {
  "title": "seek",
  "sub_text": "Powered by OpenAI",
  "questions_consumed": "Questions consumed",
  "suggested_assets": "To better understand the topic, we suggest you read the asset provided below. It will give you more information and help you learn more.",
  "summarize_asset": "Summarize this asset",
  "placeholders": {
    "how_to": "How to",
    "show_me": "Show me",
    "how_does": "How does",
    "what_is": "What is",
    "follow_on": "Type your follow on question",
    "seek_disabled": "Looks like you have exhausted all your tokens to SEEK.",
    "global": [
      "Rummaging through the archives to unravel the mysteries of the universe...just a few more moments!",
      "Searching for answers in all documents, so you don't have to go full detective mode!",
      "Roses are red, violets are blue, searching for answers, just for you!",
      "Digging through the digital haystack, to find the needle of knowledge you seek!",
      "Putting on my detective hat and scouring the documents for clues to solve the mystery!"
    ],
    "asset": [
      "Rummaging through the archives to unravel the mysteries of the universe...just a few more moments!",
      "Searching for answers within the document, so you don't have to go full detective mode!",
      "Roses are red, violets are blue, searching for answers, just for you!",
      "Digging through the digital haystack, to find the needle of knowledge you seek!",
      "Putting on my detective hat and scouring the document for clues to solve the mystery!"
    ]
  },
  "fetching": {
    "asset": "Please wait, response is being generated",
    "response": "Please wait while the response is being generated",
    "session": "Loading session"
  },
  "actions": {
    "new_chat": "New Chat",
    "draft_email": "Draft an Email",
    "drafting_email": "Drafting Email",
    "add_to_collection": "Add to Collection",
    "history": "History"
  },
  "history": {
    "title": "history",
    "actions": {
      "clear_all": "Clear All"
    },
    "empty_message": "Your history will show up here."
  },
  "error_messages": {
    "no_response": "Oops! Looks like this Question did not return a response",
    "try_new_chat": "Please try again using a new chat.",
    "restriction_global": "Sincere apologies! You've reached the permissible limit on the SEEK volume. Please reach out to the {0} and they'll swiftly bring you back on track!",
    "token_expired": "We understand that you'd like to SEEK more! Unfortunately, you've reached the permissible limit on the SEEK volume. Fret not, we're here to assist! Please reach out to your {0} and they'll swiftly bring you back on track!",
    "go_to_search": "Until then, make the most of the ever-available search {0}"
  },
  "keywords": {
    "customer_success": "Customer Success Manager",
    "right_here": "right here",
  }
}